"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYDAY_TODAY_COPY = void 0;
exports.daysLeftLabel = daysLeftLabel;
exports.paydayCountCopy = paydayCountCopy;
/**
 * The pay-period countdown, in words (DASH-S09).
 *
 * `days_left` counts the days still to come AFTER today, so the period's last
 * day is 0. Rendered as `{n} days left` it read "1 days left" and, on the last
 * day, "0 days left", which sounds like the period is already over. The
 * record's expected strings: "1 day left" and "Last day".
 */
function daysLeftLabel(daysLeft) {
    if (daysLeft <= 0)
        return "Last day";
    if (daysLeft === 1)
        return "1 day left";
    return `${daysLeft} days left`;
}
/** THE next payday is today (Paul, 2026-11-02): the main paycheck lands today. */
exports.PAYDAY_TODAY_COPY = "Payday today";
/**
 * THE next payday's count, in words, from the server's `next_payday` (Home's hero,
 * Upcoming's bar): "Payday today", "1 day to payday", "9 days to payday". Only the main
 * paycheck is "payday"; a second paycheck's deposit is income, never this.
 */
function paydayCountCopy(payday) {
    if (payday.is_today)
        return exports.PAYDAY_TODAY_COPY;
    return `${payday.days} ${payday.days === 1 ? "day" : "days"} to payday`;
}
//# sourceMappingURL=periodCopy.js.map